
const state = {
    visibleFieldHeader: null,
    hiddenFieldHeader: null,
    configureTableData: null,
};

const mutations = {
    SET_VISIBLE_FIELD_HEADER: (state, info) => {
        state.visibleFieldHeader = info;
    },
    SPLICE_VISIBLE_FIELD_HEADER: (state, info) => {
        state.visibleFieldHeader.splice(info.index, 1);
    },
    SET_HIDDEN_FIELD_HEADER: (state, info) => {
        state.hiddenFieldHeader = info;
    },
    SPLICE_HIDDEN_FIELD_HEADER: (state, info) => {
        state.hiddenFieldHeader.splice(info.index, 1);
    },
    SET_CONFIGURE_TABLE: (state, info) => {
        state.configureTableData = info;
    },
};

const actions = {
    setVisibleFieldHeader({ commit }, info) {
        commit("SET_VISIBLE_FIELD_HEADER", info);
    },
    spliceVisibleFieldHeader({ commit }, info) {
        commit("SPLICE_VISIBLE_FIELD_HEADER", info);
    },
    setHiddenFieldHeader({ commit }, info) {
        commit("SET_HIDDEN_FIELD_HEADER", info);
    },
    spliceHiddenFieldHeader({ commit }, info) {
        commit("SPLICE_HIDDEN_FIELD_HEADER", info);
    },
    setConfigureTableData({ commit }, info) {
        commit("SET_CONFIGURE_TABLE", info);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/field_header.js